import React, { MouseEvent, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { IUEvent } from '../../lib/event';
import { ModalContainer } from './CommonModal';
import { Overlay } from './CommonModal';
import ExpandingTextInput from '../ExpandingTextInput';
import { getInviteeById } from '../../lib/attendance';
import ActionButton from '../buttons/ActionButton';
import { useUserContext } from '../../contexts/UserContext';
import { sendEventComment } from '../../api/ElkEventService';

import { ULogApplication, ULogSeverity, ULogTag, logSumoEvent } from 'Common/src/api/SumoLogicApi';

interface Props {
  event: IUEvent;
  inviteeId: string;
  close: () => void;
}

const CHAR_LIMIT = 900;

const AttendeeReplyModal = ({ event, inviteeId, close }: Props) => {
  const userContext = useUserContext();
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const invitee = getInviteeById(event, inviteeId);

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const sendMessage = async () => {
    setSubmitted(true);
    await sendEventComment({
      userContext,
      eventId: event.id,
      messageId: uuidv4(),
      message,
      inviteeId
    });

    close();
  };

  const onClose = () => {
    void logSumoEvent({
      app: ULogApplication.ELK,
      severity: ULogSeverity.INFO,
      userId: userContext.id,
      tag: ULogTag.UserAction,
      message: '[AttendeeReplyModal] Closed modal'
    });

    close();
  }

  return <Overlay onClick={onClose}>
    <ModalContainer onClick={onModalClick}>
      <ExpandingTextInput
        label={`Message to ${invitee?.name}`}
        value={message}
        textColor="#FFF"
        placeholder="-"
        onChange={setMessage}
        charLimit={CHAR_LIMIT}
        required={true}
      />

      <ReminderText>
        {invitee?.name} will receive either an email or a text message based on their preferences.
      </ReminderText>

      <ActionButton onClick={sendMessage} disabled={submitted}>Send</ActionButton>
    </ModalContainer>
  </Overlay>
};

const ReminderText = styled.div`
  font-style: italic;
  font-size: 14px;
`;

export default AttendeeReplyModal;
